import { CatalogItemResponseClientOwnViewModel } from '@common/model/catalog/item/response';
import { coreCurrentClientApi } from '../../api';
import { useIsLoggedIn } from '../../../currentUser';

export const useClientOwnCatalogItemResponses = (): CatalogItemResponseClientOwnViewModel[] => {
  const isLoggedIn = useIsLoggedIn();
  const { data } = coreCurrentClientApi.endpoints.getOwnCatalogItemResponses.useQuery(undefined, { skip: !isLoggedIn });
  return data ?? [];
};
